import type { MetaFunction } from "@remix-run/node";
import { getSeoMeta } from "~/utils/seo-meta";
import { SEOLayout } from "~/components/seo/SEOLayout";
import { IndustrySeoPage } from "~/components/seo/IndustrySeoPage";
import { INDUSTRY_SEO_CONFIG } from "~/utils/seo-industry-content";

export const meta: MetaFunction = () => {
  const content = INDUSTRY_SEO_CONFIG.electronics;
  return getSeoMeta({
    title: content.title,
    description: content.description,
    url: "/for/electronics",
  });
};

export default function ForElectronics() {
  return (
    <SEOLayout>
      <IndustrySeoPage content={INDUSTRY_SEO_CONFIG.electronics} />
    </SEOLayout>
  );
}
